module.exports = __webpack_public_path__ + "img/cc.a9001e3c.svg";